/**
 * Umożliwia zapamiętanie kontekstu wywołania w przypadku
 * kliknięcia odnośnika "dane i ustawienia" na boxie
 * ostatniej szansy warrantyUpsellingBox.js
 * oraz późniejszy powrót do strony wywołania
 */
app.service('upsellingContext', function ($global) {

	function setup() {
		sessionStorage.setItem("upselling", getValidUrlForStorage(location.href));
	}

	function isActive() {
		return !!sessionStorage.getItem("upselling");
	}

	function getUpsellingUrl() {
		const url = sessionStorage.getItem("upselling");
		if (isValidUrl(url)) {
			return `${url}#warranty-upselling-box`;
		}
		return '/konto.bhtml';
	}

	function clear() {
		sessionStorage.removeItem("upselling");
	}

	function getValidUrlForStorage(url) {
		const regex = /\/customer-order-preview.bhtml\?orderNumber=\d+/;
		const match = url.match(regex);

		if (match) {
			const baseUrl = new URL(match[0], location.origin);
			return baseUrl.href;
		} else {
			return null;
		}
	}

	function isValidUrl(url) {
		const regex = /^https?:\/\/[^\/]+\/customer-order-preview.bhtml\?orderNumber=\d+$/;
		return regex.test(url);
	}

	$global('isUpsellingContextActive', isActive);
	$global('getUpsellingUrl', getUpsellingUrl);

	return {
		isActive,
		setup,
		getUpsellingUrl,
		clear
	}
});